import { Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function LoadingScreen() {
  const { t } = useTranslation();
  return (
    <Box role="status" aria-label={t('common.loading')} sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <CircularProgress size={28} />
    </Box>
  );
}
